/**
 * COMPONENTE DE ESTADO DE CONEXIÓN
 * 
 * Muestra banner cuando hay problemas de conexión
 * Se auto-oculta cuando se recupera la conexión
 */

import React from 'react';
import { Wifi, WifiOff, AlertTriangle } from 'lucide-react';
import { useConnection } from '../hooks/useConnection';

const ConnectionStatus = () => {
  const { 
    isOnline, 
    isSlowConnection, 
    showOfflineMessage, 
    showReconnectedMessage 
  } = useConnection();

  // No mostrar nada si todo está bien
  if (isOnline && !showReconnectedMessage && !isSlowConnection) {
    return null;
  }

  // Mensaje de reconectado (temporal)
  if (showReconnectedMessage) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-green-500 text-white py-2 px-4 flex items-center justify-center gap-2 text-sm animate-slide-down">
        <Wifi className="h-4 w-4" />
        <span>¡Conexión restaurada!</span>
      </div>
    );
  }

  // Mensaje de conexión lenta
  if (isSlowConnection && isOnline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white py-2 px-4 flex items-center justify-center gap-2 text-sm">
        <AlertTriangle className="h-4 w-4" />
        <span>Conexión lenta detectada. Algunas funciones pueden tardar.</span>
      </div>
    );
  }

  // Mensaje de sin conexión
  if (showOfflineMessage) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-red-500 text-white py-3 px-4 flex items-center justify-center gap-2 text-sm shadow-lg">
        <WifiOff className="h-4 w-4 animate-pulse" />
        <span>Sin conexión a internet</span>
      </div>
    );
  }

  return null;
};

export default ConnectionStatus;
